import { IJPlistItem } from '../interfaces';
import { IGNORE_REGEX } from '../jplist';
import { IPurchased } from '../../../projects/membership/purchased-products/interfaces';

/**
 * text filter
 * this filter returns all items that contains the specified text in the given path
 * property - any item property; empty value meaning the whole element; 'default' means no change
 * mode - contains (default), startsWith, endsWith, equal
 * ignoreRegex - optional regex that defines what characters should be ignored
 * returns filtered items
 */
export const textFilter = (
    items: IJPlistItem[],
    text: string,
    property: string='',
    mode: string = 'contains',
    ignoreRegex: string = IGNORE_REGEX) =>{

    const filtered = [];

    if(!items) return [];

    // no change is needed
    if(property === 'default') return items;

    const formattedText = text.replace(new RegExp(ignoreRegex, 'ig'), '').toLowerCase().trim();

    for(let item of items){

        const value = (property === '' ) ? item : item[property];
        let shouldBeAdded = false;
        const itemText = value.replace(new RegExp(ignoreRegex, 'ig'), '').toLowerCase().trim();

        switch(mode){

            case 'startsWith':{
                if(itemText.startsWith(formattedText)){
                    shouldBeAdded = true;
                }
                break;
            }

            case 'endsWith':{
                if(itemText.endsWith(formattedText)){
                    shouldBeAdded = true;
                }
                break;
            }

            case 'equal':{
                if(itemText === formattedText){
                    shouldBeAdded = true;
                }
                break;
            }

            default:{
                //contains
                if(itemText.indexOf(formattedText) !== -1){
                    shouldBeAdded = true;
                }
                break;
            }
        }

        if(shouldBeAdded){
            filtered.push(item);
        }
    }

    return filtered;
};

/**
 * filter purchased items except content type 4
 * https://wavesaudio.atlassian.net/browse/DSWEB-1798
 */
export const purchasedFilter = (purchased: IPurchased, items: IJPlistItem[]) => {

    if (!purchased || !purchased.purchasedProducts || purchased.purchasedProducts.length <= 0) {
        return items;
    }

    const filtered = [];
    const purchasedProducts = purchased.purchasedProducts || [];

    if(!items) return [];

    for(let item of items){

        const purchasedFound = purchasedProducts.find(p => p.skuNumber.toLowerCase() === item.skuNumber.toLowerCase());

        if(!purchasedFound || (purchasedFound && purchasedFound.contentType === 4)){
            filtered.push(item);
        }
    }

    return filtered;
};